import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 2rem 2rem 2rem;
  position: relative;
  z-index: 2;
  @media screen and (max-width: 992px) {
    padding: 1rem 2rem;
  }
  @media screen and (max-width: 768px) {
    padding: 0 2rem;
    margin-top: 2rem;
  }
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const StyledNewsTitle = styled.h2`
  line-height: 4rem;
  font-size: 3.375rem;
  font-weight: 700;
  @media screen and (max-width: 1280px) {
    margin: 2rem 0 2rem 0;
  }
  @media screen and (max-width: 992px) {
    line-height: 1.5;
    font-size: 2.5rem;
    margin-top: 1rem;
  }
  @media screen and (max-width: 768px) {
    line-height: 1.5;
    font-size: 2rem;
  }
`;
const StyledNewsItem = styled.div`
  line-height: 24px;
  border-left: 2px dotted #f3f5ff;
  padding-bottom: 2rem;
  li {
    color: var(--text-color);
    padding-left: 2rem;
  }
  h3 {
    margin: 0 0 1rem 0;
    font-size: 1.6rem;
    line-height: 2rem;
    border-left: 10px solid #6c8ef8;
    padding-left: 2rem;
  }
`;

const News = () => {
  const [news, setNews] = useState([]);
  useEffect(() => {
    fetch("https://client-metadata.redact.dev/main/changelog.json")
      .then((res) => res.json())
      .then((body) => setNews(body?.changelog));
  }, []);

  const changelogRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (window.location.hash === "changelog") {
        changelogRef.current.scrollIntoView(true);
      }
    }, 50);
  }, []);

  return (
    <StyledWrapper ref={changelogRef}>
      <StyledContainer>
        <StyledNewsTitle>Latest changelog</StyledNewsTitle>
        {news?.slice(0, 5).map((value) => {
          return (
            <StyledNewsItem key={value.title}>
              <h3>{value.title}</h3>
              {value.details.map((detailsValue) => {
                return <li key={detailsValue}>{detailsValue}</li>;
              })}
            </StyledNewsItem>
          );
        })}
      </StyledContainer>
    </StyledWrapper>
  );
};

export default News;
